import React from 'react'
import { LiveApi } from 'live/lib/api'
import { LIVE_PERMISSIONS } from 'live/services/authorization'
import ServiceLocator from 'live/services/service-locator'
import i18n from 'live/services/i18n'
import { ptBr } from './i18n/ptBr'
import { enUs } from './i18n/enUs'
import ModelsConfigRegister from './modelsConfig/ModelsConfigRegister'

const StatusAlgorithm = React.lazy(() => import('./operation-status/StatusAlgorithm'))
const ConfigForm = React.lazy(() => import('./config/ConfigForm'))

try {
    document.addEventListener('DOMContentLoaded', function() {
        const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'en_us'
        const localeFiles = {
            pt_br: ptBr,
            en_us: enUs
        }

        i18n.add(localeFiles[locale])
    })

    LiveApi.Extension.configuration.entries.register({
        name: i18n('Rig State'),
        area: 'rig-state-settings',
        group: 'high-frequency-data',
        url: '/#/config/rig-state-settings',
        component: props => (
            <React.Suspense fallback={'loading'}>
                <ConfigForm {...props} />
            </React.Suspense>
        ),
        permissions: [
            LIVE_PERMISSIONS.ADMIN,
            LIVE_PERMISSIONS.MANAGE_HIGH_FREQUENCY_DATA,
            LIVE_PERMISSIONS.VIEW_HIGH_FREQUENCY_DATA
        ]
    })

    // ServiceLocator.getService('asset-tab-service').then(service => {
    //     service.register({
    //         step: 'operation-status-well',
    //         assetType: 'wells',
    //         label: 'Operation Status',
    //         shouldHide: false,
    //         body: props => (
    //             <React.Suspense fallback={'loading'}>
    //                 <StatusAlgorithm {...props} />
    //             </React.Suspense>
    //         )
    //     })

    //     service.register({
    //         assetType: 'rig',
    //         step: 'operation-status-rig',
    //         label: 'Operation Status',
    //         shouldHide: false,
    //         body: props => (
    //             <React.Suspense fallback={'loading'}>
    //                 <StatusAlgorithm {...props} />
    //             </React.Suspense>
    //         )
    //     })
    // })

    ServiceLocator.getService('dropdown-option').then(service => {
        service.DropdownOptionRegistry.register({ component: ModelsConfigRegister, id: 'modelsConfig' })
    })
} catch (e) {
    console.error(e)
}
